import React from "react";
import { useNavigate } from "react-router-dom";
import NavbarAdmin from "components/NavbarAdmin";


const Admin = () => {
  const navigate = useNavigate();

  // Navigate to the User Approval page
  const handleUserApproval = () => {
    navigate("/userapproval");
  };

  // Navigate to the Update Entitlement page
  const handleUpdateEntitlement = () => {
    navigate("/updateentitlement");
  };

  return (
    <div className="relative bg-gray-900_01 w-full min-h-screen p-5">
    {/* NavbarAdmin */}
    <NavbarAdmin />
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-2xl font-bold mb-6 text-gray-700">Admin Dashboard</h1>
      <div className="flex flex-col gap-4">
        {/* User Approval Button */}
        <button
          onClick={handleUserApproval}
          className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-500 transition"
        >
          User Approval
        </button>

        {/* Update Entitlement Button */}
        <button
          onClick={handleUpdateEntitlement}
          className="px-6 py-3 bg-green-600 text-white font-medium rounded-lg shadow hover:bg-green-500 transition"
        >
          Update Entitlement
        </button>
      </div>
    </div>
    </div>
  );
};

export default Admin;
